import React, { Component } from "react";
import { Row, Col, Button, Modal, Container, Form } from "react-bootstrap";
import Switch from "react-switch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class AddItemCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        itemCategory: "",
        itemCategoryDescp: "",
        isActive: true
      }
    };
  }

  handleChange = checked => {
    this.setState({ value: { ...this.state.value, isActive: checked } });
  };

  onChange = event => {
    let name = event.target.name;
    let value = event.target.value;
    if (name == "itemCategory") {
      this.setState({
        value: { ...this.state.value, itemCategory: value }
      });
    } else if (name == "itemCategoryDescp") {
      this.setState({
        value: { ...this.state.value, itemCategoryDescp: value }
      });
    }
  };

  submit = () => {
    let data = this.state.value;
    // console.log(data);

    if (data.itemCategory !== "" && data.itemCategoryDescp !== "") {
      this.props.AddItemCategory(this.state.value);
      this.setState({
        value: {
          itemCategory: "",
          itemCategoryDescp: "",
          isActive: true
        }
      });
      this.props.closeAddModel();
      this.props.resetPage();
    } else {
      toast.error("Please fill all required fields", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER
      });
    }
  };

  closeModel = () => {
    this.setState({
      value: {
        itemCategory: "",
        itemCategoryDescp: "",
        isActive: true
      }
    });
    this.props.closeAddModel();
  };
  render() {
    return (
      <div>
        <Modal
          show={this.props.showitemCategoryAddModel}
          onHide={this.closeModel}
          animation={false}
          size="md"
          backdrop="static"
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
            closeButton
          >
            <Modal.Title>Item Category</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <Col lg={12}>
                  <Form>
                    <div style={{ maxWidth: 280, margin: "auto" }}>
                      <div>
                        <Form.Group controlId="itemCategory">
                          <Form.Label> Name </Form.Label>
                          <Form.Control
                            type="text"
                            // placeholder="ItemCategory"
                            autoComplete="off"
                            name="itemCategory"
                            onChange={this.onChange}
                            value={this.state.value.itemCategory}
                          />
                        </Form.Group>
                      </div>

                      <div>
                        <Form.Group controlId="itemCategoryDescp">
                          <Form.Label>Description</Form.Label>
                          <Form.Control
                            as="textarea"
                            // placeholder="ItemCategory Description"
                            name="itemCategoryDescp"
                            autoComplete="off"
                            onChange={this.onChange}
                            value={this.state.value.itemCategoryDescp}
                          />
                        </Form.Group>
                      </div>

                      <div>
                        <label style={{ display: "flex", marginTop: "8px" }}>
                          <div style={{ marginRight: "30px" }}>
                            <span>Active</span>
                          </div>
                          <div style={{ marginTop: "-5px" }}>
                            <Switch
                              onChange={this.handleChange}
                              onColor="#20a8d8"
                              checked={this.state.value.isActive}
                            />
                          </div>
                        </label>
                      </div>
                    </div>
                  </Form>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
            <Button type="submit" onClick={this.submit}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default AddItemCategory;
